var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0L82 22V66L44 88L6 66V22L44 0Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2321 32.3417C60.4269 33.9087 61.3573 35.6127 62.082 37.5028C63.5804 36.9544 65.0494 36.4256 66.5968 35.8575C64.8144 31.1175 61.9058 27.3373 57.7827 24.3796C56.8621 25.692 55.9611 26.9749 55.0308 28.3068C56.6271 29.4722 58.0373 30.7943 59.2321 32.3417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1421 26.6024C52.808 25.1824 53.4642 23.7623 54.1693 22.2542C46.4423 19.0027 38.9111 19.1594 31.713 23.4392C24.7498 27.5818 20.9696 33.879 20 41.9879C21.6551 42.1348 23.222 42.2719 24.7792 42.4091C25.6312 30.1575 39.1658 20.7655 52.1421 26.6024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.701 45.7686C23.2124 45.8959 21.665 46.033 20.1274 46.1603C20.4898 55.9537 29.0297 66.9616 41.8983 67.9997C42.0354 66.4131 42.1725 64.8658 42.2998 63.3576C32.2419 61.6927 26.405 55.8558 24.701 45.7686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.399 44.1233C59.399 35.6324 52.4946 28.728 44.0037 28.728C35.5128 28.728 28.6084 35.6324 28.6084 44.1233C28.6084 52.6142 35.5128 59.5186 44.0037 59.5186C52.4946 59.5186 59.399 52.6142 59.399 44.1233ZM44.9439 48.3454L42.1233 51.1561L39.3126 48.3356L35.1795 44.3107L38 41.5L42.1331 45.5248L50.1893 37.1795L53 40L44.9439 48.3454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6547 39.9219C66.1172 40.1863 64.56 40.4605 62.9539 40.7347C63.7863 46.3464 62.6307 51.39 59.203 55.8264C55.7949 60.2335 51.2409 62.6525 45.6587 63.2694C45.7958 64.856 45.9329 66.3935 46.0602 67.9409C57.734 67.5296 70.25 55.8068 67.6547 39.9219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6,
    y1: 0,
    x2: 77.1411,
    y2: -3.76683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(20 20)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.a6731d9fd267031eccac3736c2d99dfb.svg";